import { defineComponent } from 'vue';
import BlueAddCart from '@/components/BlueAction/AddToCartButton.vue';
import { mapGetters } from 'vuex';
import { facebookTrackingService } from '@/services/tracking';
import TaxHint from '@/components/Blue/TaxHint.vue';
import euroFormatter from '@/services/formattter/Currency';
import blueShippingPeriodInfo from '@/components/Blue/ProductDescription/BlueShippingPeriodInfo.vue';
import eventBus from '@/services/EventBus';
export default defineComponent({
    name: 'price-cta-and-infos',
    components: {
        TaxHint,
        BlueAddCart,
        blueShippingPeriodInfo,
    },
    computed: Object.assign(Object.assign({}, mapGetters('blue', {
        currentProduct: 'currentProduct',
    })), { karnaRateCommaSeperated() {
            var _a;
            return euroFormatter.format((_a = this.currentProduct) === null || _a === void 0 ? void 0 : _a.klarnaRate);
        },
        currentPriceCommaSeperated() {
            var _a;
            return euroFormatter.format((_a = this.currentProduct) === null || _a === void 0 ? void 0 : _a.currentPrice);
        } }),
    methods: {
        dispatchPaypalExpress() {
            facebookTrackingService.trackCartAdd(this.currentProduct, 1);
            const basic_shipping_is_not_free = this.currentProduct.currentPrice < 30;
            let basic_buttontext = 'Standard (kostenlos)';
            if (basic_shipping_is_not_free) {
                basic_buttontext = 'Standard (3.99 €)';
            }
            eventBus.emit('openInfoPopup', {
                icon: 'info',
                headline: 'Wähle noch eine Versandart',
                message: 'Du hast die Wahl zwischen: <br><br> Standardversand (2-3 Werktage) <br> Expressversand (1-2 Werktage)',
                buttonConfirmText: basic_buttontext,
                buttonConfirmFunction: () => {
                    // FLAT BUTTON
                    console.log('Button 1 - FLAT');
                    window.location.replace(`/kaufen/checkout/pp_express/${this.currentProduct.id}/flat`);
                },
                buttonDenyText: 'Express (6.99 €)',
                buttonDenyFunction: () => {
                    // EXPRESS BUTTON
                    console.log('Button 2 - EXPRESS');
                    window.location.replace(`/kaufen/checkout/pp_express/${this.currentProduct.id}/express`);
                },
            });
        },
        klarnaPopUp() {
            const myhtml = '<h3 class="h5 strong">Klarna</h3>' +
                '<ul class="pl-4">' +
                '<li class="text-left">Artikel in den Warenkorb legen</li>' +
                '<li class="text-left">Gehe zur Kasse und bezahle mit Klarna</li>' +
                '<li class="text-left">Benutze die Klarna-App oder melde Dich auf klarna.de an, um deine Zahlung zu tätigen</li></ul>' +
                '<p class="font7">Je nach Zahlungsdatum kann die Höhe der monatlichen Rate und des Gesamtbetrags leicht variieren. ' +
                'Kreditgeber: Klarna Bank AB (publ), Sveavägen 46, 111 34 Stockholm, Schweden</p>' +
                '<p class="font7">Hier finden Sie ' +
                '<a class="link-gray" tabindex="0" href="https://cdn.klarna.com/1.0/shared/content/legal/terms/0/de_de/base_account" target="_blank" >' +
                'weitere Informationen</a>' +
                ', die AGB mit Widerrufsbelehrung und die ' +
                '<a class="link-gray" tabindex="0" href="https://cdn.klarna.com/1.0/shared/content/legal/de_de/account/terms.pdf" target="_blank">' +
                'AGB mit Widerrufsbelehrung</a> und die ' +
                '<a class="link-gray" tabindex="0" href="https://cdn.klarna.com/1.0/shared/content/legal/de_de/consumer_credit.pdf" target="_blank">' +
                'Standardinformationen für Verbraucherkredite</a>.' +
                '</p>';
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            window.renderAsModal(myhtml);
        },
    },
});
